<div class="container">
  <div class="close-div-icon">
    <ion-icon (click)="close()" color="black" name="close-outline"></ion-icon>
  </div>
  <img class="fullscreen-image" *ngIf="imgURL" [src]="imgURL">
</div>